import { useEffect, useState } from "react"
import { createPortal } from "react-dom"

import Icon from "../../Icon"
import ButtonComponent from "../Button"

import "./styles.less"

const ImageWithPreview = ({ src, alt, className, ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const [isClosing, setIsClosing] = useState(false)

  const handleClose = () => setIsClosing(true)

  const handleAnimationEnd = () => {
    if (isClosing) {
      setIsOpen(false)
      setIsClosing(false)
    }
  }

  useEffect(() => {
    if (!isOpen) return
    const onKey = (e) => {
      if (e.key === "Escape") handleClose()
    }
    document.addEventListener("keydown", onKey)
    return () => document.removeEventListener("keydown", onKey)
  }, [isOpen])

  const container = document.getElementById("main-layout") || document.body

  return (
    <>
      <img
        {...props}
        src={src}
        alt={alt}
        onClick={() => setIsOpen(true)}
        className={`image-preview-thumb ${className || ""}`}
      />
      {isOpen &&
        createPortal(
          <div
            className={`image-preview-overlay${isClosing ? " image-preview-overlay--closing" : ""}`}
            onClick={handleClose}
            onAnimationEnd={handleAnimationEnd}
          >
            <div className="image-preview-container" onClick={(e) => e.stopPropagation()}>
              <ButtonComponent
                size="large"
                icon={<Icon type="close_modal" />}
                onClick={handleClose}
                className="image-preview-close-btn"
              />
              <img src={src} alt={alt} />
            </div>
          </div>,
          container
        )}
    </>
  )
}

export default ImageWithPreview
